module.exports = __webpack_public_path__ + "static/media/c13b6d61-ca04-49dd-96df-00da55c9f94e.ce5e5c5c.JPG";